import normalizeHotel from './normalize/hotel';

export default function normalizeHotelReservation(data = {}) {
    return normalizeHotel(data);
}
